export default __webpack_public_path__ + "static/media/burger.5d6b6918.jpg";